import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import UserDetailsElement from 'components/users/UserDetailsElement';
import UserDetailsRow from 'components/users/UserDetailsRow';
import EmailLink from 'components/EmailLink';
import styles from './styles.scss';
import UserType from 'types/user';
import { can } from '../../../../services/ability';
import { VENDOR_NAME_MAP } from 'config/constants';

const UserDetailsBasicInfo = ({
  contractorTableApprovedField, leadCertField, canDeliverField, user, role,
}) => <Fragment>
  <UserDetailsRow title="Contact Information">
    <UserDetailsElement title="email address">
      <EmailLink email={user.email}>{user.email}</EmailLink>
    </UserDetailsElement>
    <UserDetailsElement title="Primary Phone">
      {user.primary_phone}
      <span className={styles.userDetailsPhoneType}>
        &nbsp;({user.primary_phone_type})
      </span>
    </UserDetailsElement>
    <UserDetailsElement
      title="Secondary Phone"
      value={user.secondary_phone}
      isValueOptional
    >
      {user.secondary_phone}
      <span className={styles.employeeDetailsPhoneType}>
        &nbsp;({user.secondary_phone_type})
      </span>
    </UserDetailsElement>
  </UserDetailsRow>
  {can(role, 'view', 'manage_vendors') && (<UserDetailsRow title="Vendor Access">
    {Object.entries(user.manage_vendor_workrooms).map(([vendor, hasAccess]) => {
      const upperVendor = vendor.toUpperCase();
      return (<UserDetailsElement key={upperVendor} title={VENDOR_NAME_MAP[upperVendor]}>
        {hasAccess ? 'Yes' : 'No'}
      </UserDetailsElement>);
    })}
  </UserDetailsRow>)}
  {role !== 'estimator' && (<UserDetailsRow title="Additional Information">
    <UserDetailsElement title="Timezone">
      {user.timezone}
    </UserDetailsElement>
    {leadCertField && <UserDetailsElement title="Lead Cert Number">
      {user.lead_cert_number || '----'}
    </UserDetailsElement>}
    {contractorTableApprovedField && <UserDetailsElement title="Contractor Table Approved">
      {user.contractor_table_approved ? 'Yes' : 'No'}
    </UserDetailsElement>}
    {canDeliverField && <UserDetailsElement title="Can Deliver">
      {user.can_deliver ? 'Yes' : 'No'}
    </UserDetailsElement>}
    {user.type !== 'estimator' && <UserDetailsElement title="LRRP Training Expiration">
      {(user.lrrp_date_expiration || '').toString() || '----'}
    </UserDetailsElement>}
  </UserDetailsRow>)}
</Fragment>;
UserDetailsBasicInfo.defaultProps = {
  contractorTableApprovedField: false, leadCertField: false, role: '',
};

UserDetailsBasicInfo.propTypes = {
  canDeliverField: PropTypes.bool,
  contractorTableApprovedField: PropTypes.bool,
  leadCertField: PropTypes.bool,
  user: UserType.isRequired,
  role: PropTypes.string,
};

export default UserDetailsBasicInfo;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsBasicInfo/index.jsx